import React, { useState, useMemo, useEffect } from "react"
import { Row, Col, Card, Table, Modal, Label, Form } from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
// assets
import Loader from "pages/Separate/Loader"
import NewPagination from "components/Common/Newpagination"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import {
  approvalDelayColumns,
  delayTasksColumns,
  DashboardSwipesColumns,
} from "utils/columns/Dashboard/dashboardColumns"
import {
  fetchNodeData,
  FetchNodePostData,
} from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"
import { customGlobalFilter } from "utils/common-helpers"
import { DatePicker } from "antd"
import moment from "moment"
import { resaonOtption } from "utils/common-options"
const { RangePicker } = DatePicker

function TableContainer({
  columns,
  data,
  tab,
  tabs,
  setTab,
  delayedTaskCount,
  BATaskCount,
  dateRange,
  setDateRange,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )
  const { pageIndex, pageSize, globalFilter } = state

  useEffect(() => {
    setPageSize(10)
  }, [])
  // Render the UI for your table

  const [fixedHeading, setFixedHeading] = useState(false)

  document.addEventListener("scroll", () => {
    if (window.scrollY > 40) {
      setFixedHeading(true)
    } else {
      setFixedHeading(false)
    }
  })

  return (
    <div>
      <Row>
        <Col xl="12">
          <div className="card-body ">
            <Row className="justify-content-between align-items-center">
              <div className="text-purple fw-bold fs-5 col-md-6 d-flex gap-4">
                Delay Reason Activities
                <div className=" d-flex gap-3">
                  {tabs.map(tb => (
                    <div
                      key={tb}
                      onClick={() => setTab(tb)}
                      style={{ userSelect: "none", fontSize: "12px" }}
                      className={`d-flex gap-1 align-items-center fw-semibold general-box border py-0 px-2 rounded ${
                        tb === tab ? "bg-purple" : "bg-light"
                      }`}
                    >
                      <span style={{ lineHeight: "25px" }}>{tb}</span>

                      {/* <h5 className="text-primary mb-0">
                        {" "}
                        : {tb === tabs[0] ? delayedTaskCount : BATaskCount}
                      </h5> */}
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-6 ">
                <div className=" d-flex align-items-center justify-content-end gap-3">
                  {tab === tabs[2] && (
                    <div>
                      <RangePicker
                        // value={dateRange}
                        style={{ width: "240px" }}
                        format="YYYY-MM-DD"
                        onChange={async dates => {
                          if (dates) {
                            const start = moment(dates[0].toDate()).startOf(
                              "day"
                            )
                            const end = moment(dates[1].toDate()).endOf("day")

                            setDateRange([
                              start.format("YYYY-MM-DD"),
                              end.format("YYYY-MM-DD"),
                            ])
                          } else{
                            setDateRange([])
                          }
                        }}
                      />
                    </div>
                  )}

                  <div
                    className="search-box me-xxl-2 my-xxl-0 d-inline-block w-100"
                    style={{ width: "250px !important;" }}
                  >
                    <div className="d-flex">
                      <div className="position-relative w-100">
                        <label
                          htmlFor="search-bar-0"
                          className="search-label w-100 mb-0"
                        >
                          <span id="search-bar-0-label" className="sr-only">
                            Search this table
                          </span>
                          <input
                            onChange={e => setGlobalFilter(e.target.value)}
                            id="search-bar-0"
                            type="text"
                            className="border-radius form-control rounded h-100 w-100"
                            placeholder={`Search...`}
                            value={globalFilter || ""}
                          />
                        </label>
                        <i className="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>

                  <div>
                    <select
                      className="border-radius form-select "
                      style={{ width: "100px" }}
                      value={pageSize}
                      onChange={e => setPageSize(e.target.value)}
                    >
                      {[10, 25, 50, 100].map(pageSize => (
                        <option key={pageSize} value={pageSize}>
                          Show {pageSize}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </Row>
            <div className="position-relative table-responsive">
              <Table className="table table-bordered mt-4" {...getTableProps()}>
                <thead className={`fixed_view_payment_table`}>
                  {headerGroups.map((headerGroup, i) => (
                    <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th
                          key={index}
                          className={` ${column.className}`}
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          <div className="d-flex align-items-center">
                            <span className="flex-grow-1  header-text">
                              {column.render("Header")}
                            </span>
                            {column.isShortIcon && (
                              <span
                                onClick={() =>
                                  column.getSortByToggleProps().onClick()
                                }
                                className="d-flex align-items-center ms-2"
                              >
                                <i
                                  title="Ascending"
                                  className={`bi bi-arrow-up info-icon ${
                                    column.isSorted && !column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                                <i
                                  title="Descending"
                                  className={`bi bi-arrow-down info-icon ${
                                    column.isSorted && column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                              </span>
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody
                  className="fix-introducer-header"
                  {...getTableBodyProps()}
                >
                  {page.map((row, i) => {
                    prepareRow(row)
                    return (
                      <tr
                        className={`row-hover `}
                        {...row.getRowProps()}
                        key={i}
                      >
                        {row.cells.map((cell, index) => {
                          return (
                            <td
                              key={index}
                              className={` ${cell.column.className}`}
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>

            <Row className="justify-content-md-end justify-content-center align-items-center">
              <NewPagination
                gotoPage={gotoPage}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                canNextPage={canNextPage}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                pageSize={pageSize}
                page={page}
                data={data}
                nextPage={nextPage}
              />
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  )
}

const DelayActivities = () => {
  const [modal_Access, setAccessDenied] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [allData, setAllData] = useState([])
  const [dateRange, setDateRange] = useState([])
  const token = secureLocalStorage.getItem("auth_token")

  const tabs = ["Delayed Tasks", "BA Extra Tasks", "Timer Logs"]

  const [tab, setTab] = useState(tabs[0])

  const toggleLoading = loading => {
    setLoading(loading)
  }

  function getFormattedDuration(start, end) {
    let startTime = moment(start)
    let endTime = moment(end)

    // handle crossing midnight
    if (endTime.isBefore(startTime)) {
      endTime.add(1, "day")
    }

    const duration = moment.duration(endTime.diff(startTime))

    const hh = String(Math.floor(duration.asHours())).padStart(2, "0")
    const mm = String(duration.minutes()).padStart(2, "0")

    return `${hh}:${mm}`
  }

  const getDelayData = async () => {
    const user_id = localStorage.getItem("auth_id")
    const response = await fetchNodeData(
      toggleLoading,
      `adminDelayedProjects`,
      token
    )
    if (response?.success) {
      setAllData(response.data)
    }
  }

  const getTimerData = async () => {
    let reqData = {}

    if (dateRange[0]) reqData.startTime = dateRange[0]
    if (dateRange[1]) reqData.endTime = dateRange[1]

    const response = await FetchNodePostData(
      toggleLoading,
      `manualTimers`,
      token,
      reqData
    )

    if (response?.data?.success) {
      const tempData = response.data.data.map(item => ({
        id: item.id,
        title: item.task?.title || "--",
        project_name: item.project?.project_name || "--",
        kam_user: {
          alias_name: item.project?.keyaccountmanager_name,
          avatar: item.project?.keyaccountmanager_avatar,
        },
        time_used:
          getFormattedDuration(item.start_time, item.end_time) + " hrs",
        status: item?.status,
        reason: resaonOtption.find(reas => reas.value == item.reason).label
      }))
      console.log("tempData", tempData)
      setData(tempData)
    }
  }

  useEffect(() => {
    if (tab === tabs[2]) {
      getTimerData()
      return
    }

    if (!allData.length) getDelayData()
  }, [tab, dateRange])
console.log(dateRange)

  useEffect(() => {
    if (allData.length && (tab === tabs[0] || tab === tabs[1]))
      setData(
        allData.filter(item =>
          tab === "BA Extra Tasks" ? item.extra_task_reason : item.delay_reason
        )
      )
  }, [tab, allData])

  const column1 = useMemo(() => {
    return delayTasksColumns(tab, tabs)
  }, [tab])

  const delayedTaskCount = useMemo(
    () => allData.filter(item => item.delay_reason).length,
    [tab, allData]
  )
  const BATaskCount = useMemo(
    () => allData.filter(item => item.extra_task_reason).length,
    [tab, allData]
  )

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="">
        <div>
          <Row>
            <Col lg="12">
              <Card>
                <div className="responsive-table">
                  <TableContainer
                    columns={column1}
                    data={data}
                    toggleLoading={toggleLoading}
                    tab={tab}
                    tabs={tabs}
                    setTab={setTab}
                    delayedTaskCount={delayedTaskCount}
                    BATaskCount={BATaskCount}
                    dateRange={dateRange}
                    setDateRange={setDateRange}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  )
}

export default DelayActivities
